import React from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemTitle,
  AccordionItemBody
} from 'react-accessible-accordion';
import { convertDateToDayMonthYear, convertTime } from '../../../../lib/formatDate';
import Immutable from 'immutable';

const TradeOffersReceivedMobile = ({ tradeOffersReceived }) => {
  return (
    <Accordion accordion={ false }>
      { tradeOffersReceived.valueSeq().map((tradeOfferReceived) => (
        <AccordionItem key={ tradeOfferReceived.get('id') }>
          <AccordionItemTitle>
            <div className='u-position-relative'>
              <div>
                <div className={ 'accordion-header__title' }>Requester</div>
                <div className={ 'accordion-header__item' }>{tradeOfferReceived.getIn(['requester', 'name'])}</div>
              </div>
              <div>
                <div className={ 'accordion-header__title' }>Offered Appt</div>
                <div className={ 'accordion-header__item' }>{convertDateToDayMonthYear(tradeOfferReceived.getIn(['offeredAppointment', 'scheduledOn']))}{' '}
                  {convertTime(tradeOfferReceived.getIn(['offeredAppointment', 'from']))}</div>
              </div>
              <div>
                <div className={ 'accordion-header__title' }>Requested Appt</div>
                <div className={ 'accordion-header__item' }>{convertDateToDayMonthYear(tradeOfferReceived.getIn(['requestedAppointment', 'scheduledOn']))}{' '}
                  {convertTime(tradeOfferReceived.getIn(['requestedAppointment', 'from']))}</div>
              </div>
              <div className='accordion__arrow' role='presentation' />
            </div>
          </AccordionItemTitle>
          <AccordionItemBody>
            <div>
              <div className={ 'accordion-header__title' }>Office</div>
              <div className={ 'accordion-header__item' }>{tradeOfferReceived.getIn(['requestedAppointment', 'office', 'name'])}</div>
            </div>
            <div>
              <div className={ 'accordion-header__title' }>Status</div>
              <div className={ 'accordion-header__item trade-post__trade-status--rejected' }>{tradeOfferReceived.get('status')}</div>
            </div>
          </AccordionItemBody>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

TradeOffersReceivedMobile.propTypes = {
  tradeOffersReceived: PropTypes.instanceOf(Immutable.Map).isRequired
};

export default TradeOffersReceivedMobile;



// WEBPACK FOOTER //
// ./app/components/reps/trade_post/rejected/TradeOffersReceivedMobile.jsx